import { FC, useEffect, useState } from 'react'

import { ButtonGroup, HStack } from '@chakra-ui/react'
import { ToolbarRotateIcon, ToolbarScaleIcon, ToolbarTranslateIcon } from '@editor/assets/icons'
import { EDITOR_SUB_TOOLS } from '@editor/config/constants'
import { TransformTypes } from '@editor/interfaces/canvas'
import { RootState, useAppDispatch } from '@editor/store/app'
import { setSelectedTransform } from '@editor/store/tool'
import { isMobile } from 'react-device-detect'
import { useSelector } from 'react-redux'

import SubToolbarButton from './components/SubToolbarButton'

const CuboidToolbar: FC = () => {
  // Store
  const dispatch = useAppDispatch()
  const message = useSelector((state: RootState) => state.attentionText.message)
  const selectedTransform = useSelector((state: RootState) => state.toolUtil.core.selectedTransform)

  // States
  const [topOffset, setTopOffset] = useState<string | number>(1)

  /**
   * Adjust top offset when message changes.
   */
  useEffect(() => {
    if (message) {
      const canvas = document.getElementById('canvasBox')
      const ele = document.getElementById('attention-text')
      if (ele && canvas) {
        const canvasRect = canvas.getBoundingClientRect()
        const eleRect = ele.getBoundingClientRect()
        setTopOffset(`${eleRect.bottom - canvasRect.top + 10}px`)
      }
      return
    }

    setTopOffset('10px')
  }, [message])

  return (
    <HStack
      left={isMobile ? '600px' : '50%'}
      transform="translateX(-50%)"
      overflow="hidden"
      position="absolute"
      gap={4}
      top={topOffset}
    >
      <ButtonGroup attached>
        <SubToolbarButton
          icon={<ToolbarTranslateIcon width="1.5em" height="1.5em" />}
          label="移動"
          toolType={EDITOR_SUB_TOOLS.CUBOID.TRANSLATE}
          onClick={() => dispatch(setSelectedTransform(TransformTypes.TRANSLATE))}
          selected={selectedTransform === TransformTypes.TRANSLATE}
        />
        <SubToolbarButton
          icon={<ToolbarScaleIcon width="1.5em" height="1.5em" />}
          label="サイズ"
          toolType={EDITOR_SUB_TOOLS.CUBOID.SCALE}
          onClick={() => dispatch(setSelectedTransform(TransformTypes.SCALE))}
          selected={selectedTransform === TransformTypes.SCALE}
        />
        <SubToolbarButton
          icon={<ToolbarRotateIcon width="1.5em" height="1.5em" />}
          label="回転"
          toolType={EDITOR_SUB_TOOLS.CUBOID.ROTATE}
          onClick={() => dispatch(setSelectedTransform(TransformTypes.ROTATE))}
          selected={selectedTransform === TransformTypes.ROTATE}
        />
      </ButtonGroup>
    </HStack>
  )
}

export default CuboidToolbar
